module.exports = __webpack_public_path__ + "static/media/Madfit_Website_02.0c5a6395.jpg";